import {
  WorkflowStepKind,
  WorkflowDashboardRunDto,
  WorkflowDashboardStepDto,
  WorkflowStepInstanceStatus,
} from 'src/@types/workflow/types';

import { STEP_KINDS } from 'src/sections/shared/workflow/stepKind';

export type RenderableRunStep = {
  step: WorkflowDashboardStepDto;
  kind: WorkflowStepKind;
};

const isAwaitingAction = (step: WorkflowDashboardStepDto) =>
  step.status === WorkflowStepInstanceStatus.Active;

export const activeStepsOf = (run: WorkflowDashboardRunDto) => run.steps.filter(isAwaitingAction);

export const isWaitingOn = (run: WorkflowDashboardRunDto, email?: string) =>
  run.steps.some((step) => isAwaitingAction(step) && step.assigneeEmail === email);

export const orderedRenderableSteps = (run: WorkflowDashboardRunDto): RenderableRunStep[] =>
  run.steps
    .map((step) => ({ step, kind: step.stepType as WorkflowStepKind }))
    .filter(({ kind }) => STEP_KINDS[kind] !== undefined);
